module.exports = __webpack_public_path__ + "img/american.6c4e513f.png";